import React from 'react'
import { connect } from 'react-redux'
import ExportarCsv from '../comum/ExportarCSV';
import $ from 'jquery';
import { formatarReal } from '../../util/numberUtil';

export class ModalPrecosRota extends React.Component {
    recuperarDadosExportacao() {
        const itens = [];
        if (this.props.precosRota && this.props.precosRota.length > 0) {
            this.props.precosRota.forEach((precoRota) => {
                const valores = [precoRota.cidadeOrigem,
                precoRota.ufCidadeOrigem,
                precoRota.cidadeDestino,
                precoRota.ufCidadeDestino,
                precoRota.tipoPreco,
                formatarReal(precoRota.valor),
                formatarReal(precoRota.valorAntt)
                ]
                itens.push(valores.concat());
            });
        }
        return [['Cidade de origem', 'UF cidade de origem', 'Cidade de destino', 'UF cidade de destino', 'Tipo de tarifa', 'Valor', 'ValorAntt']].concat(itens)
    }

    recuperarCabecalho() {
        return;
    }


    exibirRelatorio() {
        if (this.props.precosRota && this.props.precosRota.length) {
            return (<div>
                <div className="table-responsive">
                    <table className="table table-striped table-bordered" style={{ backgroundColor: '#FFF' }}>
                        <thead>
                            <tr>
                                <th scope="col">Cidade de origem</th>
                                <th scope="col">Cidade de destino</th>
                                <th scope='col'>Tipo de tarifa</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Valor ANTT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.precosRota.map((precoRota, index) =>
                                <tr key={`preco-rota-${index}`}>
                                    <td>
                                        <span> {precoRota.cidadeOrigem + '-' + precoRota.ufCidadeOrigem}</span>
                                    </td>
                                    <td>
                                        <span>{precoRota.cidadeDestino + '-' + precoRota.ufCidadeDestino}</span>
                                    </td>
                                    <td>
                                        <span>{precoRota.tipoPreco}</span>
                                    </td>
                                    <td>
                                        <span>{formatarReal(precoRota.valor)}</span>
                                    </td>
                                    <td>
                                        <span>{formatarReal(precoRota.valorAntt)}</span>
                                    </td>
                                </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
            )
        }
    }

    exibirExportacao() {
        if (this.props.precosRota && this.props.precosRota.length) {
            return <div className="d-flex flex-row-reverse mb-4 mr-4">
                <div className='pull-right'>
                    <ExportarCsv dadosCsv={this.recuperarDadosExportacao()}
                        nomeArquivo={`Relação de valores rota: ${this.recuperarNomeRota()}.csv`} />
                </div>
            </div>
        }
    }

    fecharModal() {
        $('#modalPrecosRota').modal('hide');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
    }

    recuperarNomeRota() {
        // eslint-disable-next-line no-undef
        if (this.props.painelGerencial === 'itinerario' && !_.isNil(this.props.rotaSelecionada)) {
            return this.props.rotaSelecionada.label;
        }
        
        // eslint-disable-next-line no-undef
        if (!_.isNil(this.props.rotaSelecionada) && _.size(this.props.rotaSelecionada) > 0) {
            return `${this.props.rotaSelecionada.prefixo ?
                this.props.rotaSelecionada.prefixo : 'Prefixo não informado'}: ${this.props.rotaSelecionada.cidadeOrigem.nome}-${this.props.rotaSelecionada.cidadeOrigem.uf} -> ${this.props.rotaSelecionada.cidadeDestino.nome}-${this.props.rotaSelecionada.cidadeDestino.uf} / ${this.props.rotaSelecionada.delimitacao ? this.props.rotaSelecionada.delimitacao : 'Delimitação não informada'}`            
        }
    }

    render() {
        return (
            <div className="modal fade show" id="modalPrecosRota" role="dialog"
                aria-labelledby="modalPrecosRota" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">attach_money</i>
                                <span className="vx-modal-title">Relação de valores — {this.recuperarNomeRota()}</span>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fecharModal()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            {this.exibirExportacao()}
                            {this.exibirRelatorio()}
                        </div>
                        <div className="vx-modal-footer">
                            <button type="button" className="vx-btn-secondary"
                                data-dismiss="modal" onClick={() => this.fecharModal()}>
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        precosRota: state.precosRota,
        rotaSelecionada: state.rotaSelecionada
    }
);

export default connect(mapStateToProps, {})(ModalPrecosRota)
